module.exports = __webpack_public_path__ + "static/img/WePayLogo.ac49e823.png";